/**
 * PortalResources
 *
 * Handles the setting and getting of resource categories.
 */

// the constructor for this object
function PortalResources() { }

// the object
PortalResources.prototype = {
    constructor: PortalResources,

    // make the api call to get the resources
    setResourceCategories: function(successCallback)
    {
        // build the categories url
        // var resourceCategoriesUrl = PortalConfig.resourcesUrl;
        // resourceCategoriesUrl += '/categories?catGroup=portal';

        // get the categories, and store them
        $.ajax({
            url: PortalConfig.resourceCategoriesUrl,
            method: 'GET',
            success: function(result){
                PortalMain.PortalResources._storeResourceCategoriesData(result.data);
                successCallback(true);
            },
            error: function() {
                successCallback(false);
            }
        });
    },

    // clear the resource categories from localstorage
    clearResourceCategories: function()
    {
        localStorage.removeItem('portalResourceCategories');
    },

    // get the resource categories
    getResourceCategories: function()
    {
        if (localStorage.portalResourceCategories) {
            var resourceCategoriesData = JSON.parse(localStorage.portalResourceCategories);
            return resourceCategoriesData;
        }

        return false;
    },

    // save the resource categories to localstorage
    _storeResourceCategoriesData: function(resourceCategoriesData)
    {
        resourceCategoriesData = JSON.stringify(resourceCategoriesData);
        localStorage.setItem('portalResourceCategories', resourceCategoriesData);
    },

    // get a single category
    getResourceCategory: function(categoryId)
    {
        var categories = this.getResourceCategories();
        for (var i in categories) {
            if (parseInt(categoryId) == parseInt(categories[i].id)) {
                return categories[i];
            }
        }


        return false;
    },

}
